<template>
    <navroot ptype="person" />
    <div class="content-a">
        <div class="content">
            <div class="content-top">
                <i class="i-icon avatar" :style="{ backgroundImage: 'url(' + user?.HeadPhotoPath + ')' }"></i>
                <span>{{ user?.NickName }}</span>
            </div>
            <a-form ref="ruleForm" :model="newUser" :rules="rules" :wrapper-col="wrapperCol" class="input-box">
                <a-form-item :wrapper-col="{ span: 20, offset: 2 }" class="from-item">
                    <span class="from-title item-title">基本信息</span>
                    <a-button type="primary" @click="onSubmit()">修改</a-button>
                </a-form-item>
                <a-form-item :label-col="{ span: 4, offset: 1 }" :wrapper-col="{ span: 20, offset: 2 }" ref="Sex"
                    name="Sex" class="from-item">
                    <span class="item-title">性别</span>
                    <a-radio-group v-model:value="newUser.Sex">
                        <a-radio value="男">男</a-radio>
                        <a-radio value="女">女</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item class="from-item" ref="NickName" name="NickName">
                    <span class="item-title">昵称</span>
                    <i class="i-icon item-i" v-if="!newUser.NickName && itemStudent"></i>
                    <a-input v-model:value="newUser.NickName"
                        @blur="() => { $refs.NickName.onFieldBlur(); itemStudent = true }"
                        @focus="() => { itemStudent = false }" />
                </a-form-item>
                <a-form-item class="from-item" ref="StudentID" name="StudentID">
                    <span class="item-title">学号</span>
                    <i class="i-icon item-i" v-if="!newUser.StudentID && itemStudent"></i>
                    <a-input v-model:value="newUser.StudentID"
                        @blur="() => { $refs.StudentID.onFieldBlur(); itemStudent = true }"
                        @focus="() => { itemStudent = false }" />
                </a-form-item>
                <a-form-item class="from-item" ref="Phone" name="Phone">
                    <span class="item-title">手机号</span>
                    <i class="i-icon item-i" v-if="!newUser.Phone && itemPhone"></i>
                    <a-input v-model:value="newUser.Phone" @blur="() => { $refs.Phone.onFieldBlur(); itemPhone = true }"
                        @focus="() => { itemPhone = false }" />
                </a-form-item>
                <a-form-item class="from-item" ref="School" name="School">
                    <span class="item-title">所属学校</span>
                    <a-select v-model:value="newUser.School" class="select" size="large" show-search :showArrow="true"
                        :default-active-first-option="false" :filter-option="false"
                        :not-found-content="fetching ? undefined : null" :options="orgList" :disabled="logining"
                        @search="handleSearch" @change="handleChange" @blur="() => { $refs.School.onFieldBlur(); }">
                        <template v-if="fetching" #notFoundContent>
                            <a-spin size="small" />
                        </template>
                    </a-select>
                </a-form-item>
                <a-form-item class="from-item" ref="Email" name="Email">
                    <span class="item-title">电子邮件</span>
                    <i class="i-icon item-i" v-if="!newUser.Email && itemEmail"></i>
                    <a-input v-model:value="newUser.Email" @blur="() => { $refs.Email.onFieldBlur(); itemEmail = true }"
                        @focus="() => { itemEmail = false }" />
                </a-form-item>
            </a-form>
        </div>
    </div>
</template>

<script>
import navroot from '../nav/nav.vue'

export default {

    components: {
        navroot
    },

    data() {
        return {
            itemStudent: true,
            itemPhone: true,
            itemEmail: true,
            loading: true,
            logining: false,
            fetching: false,
            orgList: [],
            user: null,
            wrapperCol: { span: 20, offset: 2 },
            newUser: {
                Sex: '',
                StudentID: '',
                Phone: '',
                School: '',
                Email: '',
            },
            rules: {
                StudentID: [{ required: true, message: '学号不能为空', trigger: 'blur' }],
                NickName: [{ required: true, message: '昵称不能为空', trigger: 'blur' }],
                School: [{ required: true, message: '学校不能为空', trigger: 'blur' }],
                Phone: [
                    { required: true, message: '电话号码不能为空', trigger: 'blur' },
                    { pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/, message: '手机号格式不正确', trigger: 'blur' }],
                Email: [
                    { max: 50, message: '邮箱不得超过50字符', trigger: 'blur' },
                    {
                        pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
                        message: '邮箱格式不正确',
                        trigger: 'blur'
                    }
                ]
            },
        };
    },

    async mounted() {
        let user = this.$store.state.userInfo;
        if (!user) return;
        this.user = user;

        this.newUser = {
            Sex: user.Sex,
            NickName:user.NickName,
            StudentID: user.StudentID,
            Phone: user.Phone,
            School: user.School,
            Email: user.Email,
        };

    },
    methods: {
        onSubmit() {
            this.$refs.ruleForm.validate()
                .then(() => {
                    this.$confirm("是否确认修改信息！", () => {
                        this.updateUser();
                    })
                })
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
        //修改用户信息
        async updateUser() {
            let newUser = this.newUser;
            const params = {
                PK_UserGuid: this.user.PK_UserGuid,             // 用户guid(必传)
                ...newUser
            }
            let res = await this.$api.classMessage.updateStudent(params);
            this.logining = false;
            if (res.statusCode != 200) return this.$message.warning(res.msg);
            this.$message.success("修改成功！");
        },
        //搜索学校
        async handleSearch(val) {
            if (!val || this.fetching) return;
            this.fetching = true;
            let orgList = await this.$api.classMessage.searchOrg({ keyWord: val }).then(res => res.data);
            orgList.forEach(item => {
                item.value = item.PK_OrgGuid;
                item.label = item.Name;
            });
            setTimeout(() => { this.fetching = false; }, 300);
            this.orgList = orgList;
        },
        //选择学校
        handleChange(val) {
            let org = this.orgList.find(item => item.PK_OrgGuid == val);
            this.newUser.FK_OrgGuid = val;
            this.newUser.School = org.Name;
        },
    },
}

</script>

<style scoped lang="scss">
@import './personal-certer.scss';
</style>
